import { render, staticRenderFns } from "./DragAndDrop.vue?vue&type=template&id=16652522&scoped=true&"
import script from "./DragAndDrop.vue?vue&type=script&lang=ts&"
export * from "./DragAndDrop.vue?vue&type=script&lang=ts&"
import style0 from "./DragAndDrop.vue?vue&type=style&index=0&id=16652522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16652522",
  null
  
)

export default component.exports